export default __webpack_public_path__ + "static/media/qr-a4.a731618d.jpg";